// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"42f95502","98":"cf6f4386","157":"34176ea6","390":"7e2cb870","453":"80c0cb95","465":"86731df9","493":"6ba28aff","567":"c7dc9110","635":"de6dfa9f","700":"65a2f90a","837":"0916475f","922":"60349919","953":"05e786d3"}[chunkId] + ".chunk.js";
};